export function transformObjectToArrayByKey<T extends Record<string, any>>(obj: T, searchKey: string): { key: string, value: any }[] {
  return Object.keys(obj)
    .map(key => ({
      key: key,
      value: obj[key]
    })).filter(obj => containsDispersedSubstring(obj.key, searchKey));
}

export function containsDispersedSubstring(mainString: string, searchString: string): boolean {
  let currentIndex = 0;

  for (const char of searchString) {
    currentIndex = mainString.indexOf(char, currentIndex);
    if (currentIndex === -1) {
      return false;
    }
    currentIndex++;
  }

  return true;
}

export function getIdByFormKey(key: string) {
  return key.split("_")[1]
}